module.exports = __webpack_public_path__ + "static/media/img2.c47af5f0.jpg";